// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2qteh","list":"BalanceDue_list__2CtTS","listRow":"BalanceDue_listRow__1XYbc","total":"BalanceDue_total__2m5_-"};